import {
  getSignPageModel,
  sendSignCode,
  verifySignCode,
  submitSignature as submitSignatureHandler,
} from '../../../utils/apiHandlers';

const unwrap = (response) => {
  if (response?.success === false) {
    throw new Error(response.message || 'REQUEST_FAILED');
  }

  return response?.data ?? response;
};

export const fetchSignPageModel = async (signKey) => unwrap(await getSignPageModel(signKey));

export const sendCode = async (signKey, method) => unwrap(await sendSignCode(signKey, method));

export const verifyCode = async (signKey, code) => unwrap(await verifySignCode(signKey, code));

export const submitSignature = async (signKey, signatureImage) =>
  unwrap(await submitSignatureHandler(signKey, {signatureImage, consentAccepted: true}));
